export default __webpack_public_path__ + "static/media/37000_800x600px-Front.32f00698.png";